import { SourcesList } from 'ai-components-ui-library/components/informative/sources/SourcesList';
import unescapedText from 'I18n/utils/unescapedText';
import { groupBy } from '../../utils/groupBy';
import { isCrmDataCitation, isWebDataCitation } from './types';
import { useMemo } from 'react';
import { CitationSourceButton } from './CitationSourceButton';
import { ObjectTypeDefinitionsProvider } from '../ObjectTypeDefinitionsProvider/ObjectTypeDefinitionsProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const getSourceTypeTitle = sourceType => {
  switch (sourceType) {
    case 'com.hubspot.custom.enrichment.models.CrmDataCitationBase':
      return unescapedText('citation.sourcesList.crmDataTitle');
    case 'com.hubspot.custom.enrichment.models.WebDataCitation':
      return unescapedText('citation.sourcesList.webDataTitle');
    default:
      // TODO: Uncomment this once we are no longer in active development for citations and we can expect the types to be more stable.
      // assertUnreachable(sourceType);
      return '';
  }
};
const getSourceKey = source => {
  if (isCrmDataCitation(source)) {
    return `${source.propertyName}-${source.objectId}-${source.objectTypeId}`;
  }
  if (isWebDataCitation(source)) {
    return `${source.url}-${source.domain}`;
  }

  // TODO: Uncomment this once we are no longer in active development for citations and we can expect the types to be more stable.
  // assertUnreachable(source);
  return '';
};
export const CitationsSourcesList = ({
  sources
}) => {
  const sourcesByType = useMemo(() => groupBy(sources, source => source.__typename), [sources]);
  if (sources.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(ObjectTypeDefinitionsProvider, {
    children: /*#__PURE__*/_jsx(SourcesList, {
      children: Object.keys(sourcesByType).map(sourceType => {
        const sourcesOfType = sourcesByType[sourceType];
        return /*#__PURE__*/_jsx(SourcesList.Section, {
          title: getSourceTypeTitle(sourceType),
          children: sourcesOfType.map(source => /*#__PURE__*/_jsx(CitationSourceButton, {
            source: source
          }, getSourceKey(source)))
        }, sourceType);
      })
    })
  });
};